module.exports = __webpack_public_path__ + "582ac753900bb91b7b5dc42107791c8a.pdf";